// extracted by mini-css-extract-plugin
export default {"signInWrapper":"join-organization-auth_signInWrapper__e6giP","mainWrapper":"join-organization-auth_mainWrapper__diNdZ","infoBox":"join-organization-auth_infoBox__S4cwS"};